import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cva } from "class-variance-authority"
import type { VariantProps } from "class-variance-authority"

const switchVariants = cva("ui-switch peer", {
  variants: {
    size: {
      tiny: "h-3 w-5",
      xs: "h-3.5 w-6",
      sm: "h-4 w-7",
      md: "h-5 w-9",
      lg: "h-6 w-11",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

const SwitchThumbVariants = cva("ui-switch__thumb", {
  variants: {
    size: {
      // The indeterminate translate is half of checked — the thumb rests
      // mid-track. Radix never emits that state; only SwitchTriState does.
      tiny: "w-2 h-2 data-[state=checked]:translate-x-2 data-[state=indeterminate]:translate-x-1",
      xs: "w-2.5 h-2.5 data-[state=checked]:translate-x-2.5 data-[state=indeterminate]:translate-x-[5px]",
      sm: "w-3 h-3 data-[state=checked]:translate-x-3 data-[state=indeterminate]:translate-x-1.5",
      md: "w-4 h-4 data-[state=checked]:translate-x-4 data-[state=indeterminate]:translate-x-2",
      lg: "w-5 h-5 data-[state=checked]:translate-x-5 data-[state=indeterminate]:translate-x-2.5",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

export type SwitchProps = React.ComponentProps<typeof SwitchPrimitives.Root> &
  VariantProps<typeof switchVariants>

const Switch = ({ size, className, ...props }: SwitchProps) => (
  <SwitchPrimitives.Root
    className={switchVariants({ size, className })}
    {...props}
  >
    <SwitchPrimitives.Thumb className={SwitchThumbVariants({ size })} />
  </SwitchPrimitives.Root>
)
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch, switchVariants, SwitchThumbVariants }
